// extracted by mini-css-extract-plugin
module.exports = {"viewModals":"CreateDataProductModal_viewModals__jsR-l","dataProductForm":"CreateDataProductModal_dataProductForm__3c1aS"};